module.exports = __webpack_public_path__ + "static/media/toronto_skyline.d4374509.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/toronto_skyline.svg
// module id = 1877
// module chunks = 0